import * as React from "react";

const PassportIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      stroke="#000"
      d="M24.667 7.333h2.666v24H4.667V4.667c11.333-1.334 19.666-4 19.666-4h.334zm0 0H8m14 12a6 6 0 0 0-6-6m6 6a6 6 0 0 1-6 6m6-6c-.667.667-2.667 1.334-6 1.334s-5.333-.667-6-1.334m6-6a6 6 0 0 0-6 6m6-6c1.288 0 2.333 2.687 2.333 6s-1.045 6-2.333 6m0-12c-1.288 0-2.333 2.687-2.333 6s1.045 6 2.333 6m0 0a6 6 0 0 1-6-6"
    ></path>
  </svg>
);

export default PassportIcon;
